import React, { useState, Children, isValidElement, cloneElement, useRef } from "react";
import ArrowDropDownFilled from "./ArrowDropDownFilled.svg";
import Option from "./option";
import { useOutsideAlerter } from "./hooks";

export default function Select({ name, label, style, form, setForm, children }) {
  const formValue = form[name] === null || form[name] === undefined ? "" : form[name].toString();
  const [showOptions, setShowOptions] = useState(false);
  const ref = useRef(null);
  const childrenWithProps = Children.map(children, (child, idx) => {
    if (isValidElement(child)) {
      return cloneElement(child, {
        name,
        form,
        setForm,
        showOptions,
        setShowOptions
      });
    }
    return child;
  });
  const [selectedLabel] = Children.map(children, (n) => n.props).filter(
    (n) => n.value.toString() === formValue
  );
  useOutsideAlerter(ref, showOptions, setShowOptions);
  const error = form.errors !== null ? form.errors[name]?.reduce((n, m) => m, []) : null;
  function handleClick() {
    setShowOptions(!showOptions);
  }
  return (
    <div style={{ position: "relative", ...style }}>
      <div
        ref={ref}
        style={{
          border: "1px solid rgba(0, 0, 0, .23)",
          borderRadius: 4,
          cursor: "pointer",
          flexGrow: 1,
          height: "3.4rem",
          overflow: showOptions ? "visible" : "hidden",
          padding: "1rem .5rem",
          position: "relative",
          zIndex: showOptions ? 1 : 0
        }}
        onClick={handleClick}
      >
        <Option
          value=""
          name={name}
          form={form}
          setForm={setForm}
          showOptions={showOptions}
          setShowOptions={setShowOptions}
          showBorder={false}
        >
          {selectedLabel === undefined ? label : selectedLabel.children}
        </Option>
        <div
          style={{
            borderBottom: showOptions ? "1px solid rgba(0, 0, 0, .23)" : "none",
            borderBottomLeftRadius: showOptions ? 4 : "none",
            borderBottomRightRadius: showOptions ? 4 : "none",
            borderLeft: showOptions ? "1px solid rgba(0, 0, 0, .23)" : "none",
            borderRight: showOptions ? "1px solid rgba(0, 0, 0, .23)" : "none",
            maxHeight: 200,
            overflow: "scroll",
            position: "relative",
            visibility: showOptions ? "visible" : "hidden"
          }}
        >
          <div style={{ position: "relative", zIndex: showOptions ? 10000 : 0 }}>
            {childrenWithProps}
          </div>
        </div>
        <ArrowDropDownFilled
          style={{ position: "absolute", top: "1rem", right: ".5rem", width: 24, height: 24 }}
        />
      </div>
      <div
        style={{
          backgroundColor: "rgb(255, 255, 245)",
          bottom: "-.5rem",
          color: "red",
          padding: "0 .5rem",
          position: "absolute",
          right: ".5rem"
        }}
      >
        {error}
      </div>
    </div>
  );
}
